import { connect } from 'react-redux'

import { RootState } from '@stores'
import { ECurrency, isoToECurrency } from '@stores/types/*'

import { TPaymentGateway } from '../../../../stores/types/TPaymentGatewayState'
import SellBankMethodPage from './SellBankMethodPage'
import SellImpsMethodPage from './SellImpsMethodPage'

interface StateProps {
  paymentGateway?: TPaymentGateway
}

type Props = StateProps

const SellWrapperMethodPage = (props: Props) => {
  const toCurrency = isoToECurrency(props.paymentGateway?.currencyTo)
  switch (toCurrency) {
    case ECurrency.INR:
      return <SellImpsMethodPage />
    case ECurrency.THB:
    case ECurrency.VND:
      return <SellBankMethodPage />
    default:
      throw new Error(`Unexpected currency ${toCurrency} for sell`)
  }
}

const mapStateToProps = (state: RootState): StateProps => ({
  paymentGateway: state.payForm?.paymentGateway,
})

export default connect(mapStateToProps)(SellWrapperMethodPage)
